import React, { useEffect, useState } from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navItems = [{
    id: 'inicio',
    label: t('Inicio', 'Home')
  }, {
    id: 'sobre-mi',
    label: t('Sobre Mí', 'About Me')
  }, {
    id: 'servicios',
    label: t('Servicios', 'Services')
  }, {
    id: 'recursos',
    label: t('Recursos', 'Resources')
  }, {
    id: 'testimonios',
    label: t('Testimonios', 'Testimonials')
  }, {
    id: 'contacto',
    label: t('Contacto', 'Contact')
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`} data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="flex justify-between items-center h-20" data-id="element-126">
          <button onClick={() => scrollToSection('inicio')} className="text-xl font-bold text-[#1a365d] hover:text-[#d97706] transition-colors" data-id="element-127">
            Jesús Silva
          </button>

          <div className="hidden md:flex items-center space-x-8" data-id="element-128">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-700 hover:text-[#d97706] transition-colors font-medium" data-id="element-129">
                {item.label}
              </button>)}
            <div className="flex items-center bg-gray-100 rounded-lg p-1" data-id="element-130">
              <button onClick={() => setLang('es')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${lang === 'es' ? 'bg-[#d97706] text-white shadow-sm' : 'text-gray-600 hover:text-[#1a365d]'}`} data-id="element-131">
                ES
              </button>
              <button onClick={() => setLang('en')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${lang === 'en' ? 'bg-[#d97706] text-white shadow-sm' : 'text-gray-600 hover:text-[#1a365d]'}`} data-id="element-132">
                EN
              </button>
            </div>
          </div>

          <div className="md:hidden" data-id="element-133">
            <div className="flex items-center bg-gray-100 rounded-lg p-1" data-id="element-134">
              <button onClick={() => setLang('es')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${lang === 'es' ? 'bg-[#d97706] text-white shadow-sm' : 'text-gray-600'}`} data-id="element-135">
                ES
              </button>
              <button onClick={() => setLang('en')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${lang === 'en' ? 'bg-[#d97706] text-white shadow-sm' : 'text-gray-600'}`} data-id="element-136">
                EN
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>;
}